module.exports = __webpack_public_path__ + "img/espaço-7.41a7dae7.jpeg";